import { render, staticRenderFns } from "./GamesMenu.vue?vue&type=template&id=2c1f873a&lang=pug"
import script from "./GamesMenu.vue?vue&type=script&lang=js"
export * from "./GamesMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports